export const MicroTableWrapper = ({ children }: any) => {
  return <div className="micro-table-wrapper" data-testid="micro-table-wrapper-box">{children}</div>;
};
